var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionGroupSelectAll({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0a2 2 0 0 0-2 2v10h16V4a2 2 0 0 0-2-2h-6l-1.6-2H6Z",
    opacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 2a2 2 0 0 0-2 2v12h18V6a2 2 0 0 0-2-2h-7l-2-2H5Z",
    opacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-8l-2-2H4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionGroupSelectAll);
export default __webpack_public_path__ + "static/media/ic_action_group_select_all.eb8a4ebccd71855d2df3dbad96ec77f8.svg";
export { ForwardRef as ReactComponent };